

export default function install ( mod, prefix ) 
{
    prefix = prefix || '';

    mod.directive(_.camelCase(prefix + 'ExibirDurante'), function () {
        return {
            restrict: 'A',
            controller: ['$scope', '$localStorage', function($scope, $localStorage){

                $scope.$storage = $localStorage.$default({})
                
            }],
            link: function($scope, $element, $attrs){

                var id = $attrs.id;
                var target = _.camelCase('exibir-'+id);

                if(id) {

                    if(!$scope.$storage[target]) {
                        $scope.$storage[target] = moment().add($attrs.dias | 2, 'days')
                    } else {
                        if (moment($scope.$storage[target]).isBefore(new Date())) {
                            $element.css({ display: 'none' })
                        } else {
                            $attrs.$set('title', 'Este aviso será removido ' + moment().to($scope.$storage[target]))
                            $element.css({ display: 'inline-block' })
                        }
                    }

                }


            }
        }
    })

    mod.directive(_.camelCase(prefix + 'Odometer'), [function () {
        return {
            restrict: 'A',
            scope: { valor: '=' },
            link: function ($scope, $el, $attrs) {
                var opts, odometer;

                opts = $scope.$eval($attrs.options) || {}
                opts.el = $el[0]
                odometer = new Odometer(opts);

                $scope.$watch('valor', function (valor) {
                    odometer.update(valor)
                }, true)

            }
        }
    }])

    mod.directive(_.camelCase(prefix + 'Scroll'), ['Event', function(Event) {

        var cache = {};

        const isChrome = typeof chrome !== 'undefined' && chrome.webstore

        return {
            restrict: 'A',
            link: function ($scope, $element, $attrs) {

                var key = "scroll-" + ($attrs.id || 'position');

                var body = document.body,
                    html = document.documentElement,
                    top = 0, scrollTotal = 0, parte = 0,
                    height = 0;

                Event.on('window.resize', function () {
                    resize()

                    setTimeout(function () {
                        $scope.$digest()
                    }, 100)
                })

                function resize () {

                    height = window.innerHeight;

                    $($element).css({
                        'height': (height - $element[0].offsetTop - 120 + (parseInt($attrs.offset || 0)) ) + 'px',
                        'overflow': isChrome ? 'overlay' : 'auto'
                    }).ready(function () {

                        $($element).stop().animate({
                              scrollTop: cache[key]
                        }, 1200, 'swing' );

                    });
                }

                $($element).scroll(function () {

                    top = $($element).scrollTop();
                    scrollTotal =$element[0].scrollHeight;
                    scrollTotal = scrollTotal - (scrollTotal  * 0.18); // tamanho total de scroll
                    parte = scrollTotal - ( scrollTotal * 0.10 ); // parte do scroll

                    // 6 <- top - posicao atual
                    // 10 <- scroll total
                    // 10 - (10 * 0.10) = 9
                    // 6 > 9

                    if (top > parte ) {
                        Event.emit('scroll:final')
                    }

                    cache[key] = top;

                    if (top > 0) {
                        $element.css({
                            'border-top': '4px solid #e8e8e8',
                            'border-botton': '1px solid #e8e8e8'
                        });
                    } else {
                        $element.css({
                            'border-top': 'none',
                            'border-botton': 'none'
                        });
                    }
                });
                                
                window.addEventListener('resize', _.debounce(function(){
                    resize()

                    $scope.$digest()
                }), 100);

                resize()

            }
        }
    }])

    var isActive = false;   
    mod.directive(_.camelCase(prefix + 'CapsLock'), function () {
        return {
            restrict: 'A',
            link: function ($scope, $elem, $attrs) {

                var $target = '.' + ($attrs.target || 'icon-caps-lock')

                $(document).bind("keydown", function (event) {
                    if (event.keyCode === 20 ) { 
                        capsLock(!isActive); 
                    }
                });

                $(document).bind("keypress", function (event) {
                    var code = event.charCode || event.keyCode;
                    var shift = event.shiftKey;

                    if (code > 96 && code < 123) { capsLock(false); }
                    if (code > 64 && code < 91 && !shift) { capsLock(true); }
                });

                function capsLock (visible) {
                    if (visible) {
                        $($target).show()
                    } else {
                        $($target).hide()
                    }

                    isActive = visible;
                }
                
            }
        }
    })

}




//////////////////
// WEBPACK FOOTER
// ../Projecao.ContactCenter.WebApp.Compartilhado/plugins/ui.plugin.js
// module id = 326
// module chunks = 1